const ComingSoon = () => {
  return (
    <div className="text-center" style={{ display: "none" }}>
      <hr className="invis1" />
      <h3 style={{ color: "rgb(192, 25, 25)", fontWeight: 700 }}>
        Coming Soon
      </h3>
    </div>
  );
};

export default ComingSoon;
